export default function isImageUrl(str) {
  const regex =
    /\.(webp|png|jpg|gif|bmp)(\?.+)$|^https:\/\/cdn\.media\.amplience\.net/;
  return regex.test(str);
}
